// just a little helper, since this is used everywhere to extract the mediaId
const mediaId = page => page.data.previewImage || page.data.thumbnail || null;

// this map function is used in each filterview to generate the entries which will be display by the result list
const toFilterEntries = page => ({
  uuid: page.uuid,
  title: page.title,
  type: page.type,
  subtitle: page.data.subtitle,
  createdAt: page.createdAt,
  updatedAt: page.updatedAt,
  place: page.data.place,
  address: page.data.address,
  date: page.data.date,
  startDate: page.data.startDate || null,
  endDate: page.data.endDate || null,
  abstract: page.data.abstract,
  website: page.data.website,
  tags: page.tags,
  mediaId: mediaId(page),
});

// used in home component
const toEvent = event => ({
  uuid: event.get('uuid'),
  title: event.get('title'),
  startDate: event.getIn(['data', 'startDate']) || null,
  endDate: event.getIn(['data', 'endDate']) || null,
  createdAt: event.get('createdAt'),
  place: event.getIn(['data', 'place']),
  tags: event.get('tags'),
  mediaId: mediaId(event),
});

// used in home component
const toNews = (news, i, all) => ({
  uuid: news.get('uuid'),
  title: news.get('title'),
  abstract: news.getIn(['data', 'abstract']),
  startDate: news.getIn(['data', 'startDate']) || null,
  endDate: news.getIn(['data', 'endDate']) || null,
  createdAt: news.get('createdAt'),
  subtitle: news.getIn(['data', 'subtitle']),
  tags: news.get('tags'),
  mediaId: mediaId(news),
  lastRow: all.length >= 2,
});

// used in home component
const toMarketNews = marketNews => ({
  uuid: marketNews.get('uuid'),
  title: marketNews.get('title'),
  abstract: marketNews.getIn(['data', 'abstract']),
  startDate: marketNews.getIn(['data', 'startDate']) || null,
  endDate: marketNews.getIn(['data', 'endDate']) || null,
  createdAt: marketNews.get('createdAt'),
  subtitle: marketNews.getIn(['data', 'subtitle']),
  tags: marketNews.get('tags'),
  mediaId: mediaId(marketNews),
});

const toSearchResults = result => ({
  score: result.score,
  ...result.result,
  mediaId:
    result.result.data.thumbnail || result.result.data.previewImage || null,
  date: result.result.data.date,
  startDate: result.result.data.startDate || null,
  endDate: result.result.data.endDate || null,
});

export { toFilterEntries, toEvent, toNews, toMarketNews, toSearchResults };
